import React, { Component } from 'react';
//import Helmet from 'react-helmet';
import './content/content.css';
import InnerFeature from './content/InnerFeature';

class SearchUseCases extends Component {

  render() {

    return (
      <div>

  			<InnerFeature label="Researchers">
      			Ask harder questions, go deeper, discover new associations, build comprehensive reports not possible with ordinary search engines. Validate your assumptions. Webfinery Search allows for fast, interactive and accurate source code search across millions of websites.
   			</InnerFeature>

  			<InnerFeature label="Growth Hackers">
      			Find unique growth opportunities. Webfinery Search allows for searching in websites source code, identify web technologies, keywords, links, and much more, plus indexes server HTTP headers revealing servers and CDNs the websites are served from, creating a plethora of data points, that can be translated into growth opportunities.
   			</InnerFeature>

  			<InnerFeature label="Bloggers">
      			<p>
      					A blog post based on hard data is the best way to provide a value to your readers. Use Webfinery Search to base your conclusions on facts, not opinions. <a href="mailto:partners@webfinery.com">Send us a message</a> to discuss our special professional blogger discount.

      				</p>
   			</InnerFeature>
      	

      		<InnerFeature label="Sales">
      				<p>
      					Need a new source of leads with a conversation starter? Discover websites using specific technologies, relevant your ideal customer persona. Export lists of domains for further prospecting.
      				</p>
      		</InnerFeature>

				<InnerFeature label="Marketing">
      				<p>
      					Research the web technology market, build an accurate and targeted customer persona based on technologies used, find new ideas and accurate data to write about on your company blog. <a href="mailto:partners@webfinery.com">Get in touch</a> and say hello if you’re planning on mentioning Webfinery in your blog post.
      				</p>
      			</InnerFeature>

      				<InnerFeature label="Competitive Intelligence">
      				<p>
      					Who are your competitors? Where do they advertise? Who uses products and services provided by your competitors? What web technologies your competitors rely on? Use Webfinery Search to find out.
      				</p>
      			</InnerFeature>

      				<InnerFeature label="Cyber Security">
      				<p>
      					Search across millions of websites and their source code. Assess vulnerability reach, identify websites, create reports, prevent malicious attacks.
      				</p>
      				</InnerFeature>
      				<InnerFeature label="Web Professionals">
      					<p>
      						Find websites using specific JavaScript library, a Wordpress theme, and much more. As long as it’s mentioned in the source code, Webfinery Search has it for you.
      					</p>
      				</InnerFeature>
      </div>
    );
  }
}

export default SearchUseCases;



// WEBPACK FOOTER //
// ./src/SearchUseCases.js